const LoadingSpinner = () => (
  <div className="size-8 animate-spin rounded-full border-4 border-red-600 border-t-transparent" />
);

export default LoadingSpinner;
